import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import useApi from '../../hooks/useApi';
import Form from '../common/Form';
import ExhibitorCard from '../exhibitor/ExhibitorCard';
//
// Компонент выводит список экспонентов управляемых пользователем (компанией).
//
const UserToExhibitorList = ({ user }) => {
	const { t } = useTranslation();
    const navigate = useNavigate();
    const auth = useSelector(state => state.auth.user);
    const [ showArchived, setShowArchived ] = useState(false);
    // eslint-disable-next-line
    const [ params, setParams ] = useState({ admin: user._id });
	const [ data, error, isLoading ] = useApi({ type: 'get', method: '/exhibitors', params });
    const [ exhibitors, setExhibitors ] = useState([]);

    useEffect(() => {
        if(!data) return;
        let exhibitors = data.exhibitors.filter(e => e.event.is_archived === showArchived);
        setExhibitors(exhibitors);
    }, [ data, showArchived ]);

	return (
    <div>
        <h2>
            {t('e2e.exhibitors')}
            {showArchived
            ? <span onClick={() => setShowArchived(false)}>{t('e2e.show_actual')}</span>
            : <span onClick={() => setShowArchived(true)}>{t('e2e.show_archived')}</span>}
        </h2>
        {error && <div className='error'>{t(error)}</div>}
        {isLoading && <div>{t('loader.title')}</div>}
        {exhibitors.length
        ?
        <div className='grid'>
            {exhibitors.map(item => <ExhibitorCard key={item._id} exhibitor={item}/>)}
        </div> 
        :
        <div>
            {t('e2e.noexhibitors')}
        </div>}

        {/* Кнопку добавления экспонента не показываем компании и не выводим её при отображении архива */}
        {(auth.role !== 'exhibitor' && !showArchived) &&
        <Form>
            <input
                type='submit'
                value={t('e2e.add')}
                onClick={() => navigate('/cabinet/exhibitoradd/')}
            />
        </Form>}
    </div>
	);
};

UserToExhibitorList.propTypes = {
    user: PropTypes.object.isRequired,
};

export default UserToExhibitorList;
